/* eslint-disable import/no-anonymous-default-export */
import axiosInstance from "../axios/axios-configuration";
import { CancelToken } from "axios";
import { IRuolo } from "../shared/interfaces";
import { RoleContext } from "../shared/enums";

const controller = 'Roles';



const getAllRoles = (cancelToken?: CancelToken): Promise<IRuolo[]> => {
    return axiosInstance.get(`${controller}/GetAllRoles`, { cancelToken: cancelToken })
        .then(result => result.data)
        .catch(error => {
            return Promise.reject(error);
        });
}

const getAllRolesByContext = (roleContext: RoleContext, cancelToken?: CancelToken): Promise<IRuolo[]> => {
    return axiosInstance.get(`${controller}/GetAllRolesByContext/${roleContext}`, { cancelToken: cancelToken })
        .then(result => result.data)
        .catch(error => {
            return Promise.reject(error);
        });
}



export default {
    getAllRoles,
    getAllRolesByContext,
}